<template>
    <div class="mi_adtitle-box">
    <div class="mi_adtitle">
        <p class="tips">
            <svg-icon icon-class='tip'  class-name="title-tip"/>
            <span>
                每一行为一条文案，多条文案回车换行填写
            </span>
        </p>
        <div class="con">
            <div class="textarea_con">
                <div class="left">
                    <el-input
                    type="textarea"
                    :autosize="{ minRows: 20, maxRows: 50000}"
                    placeholder="请输入内容"
                    v-model="textareaDemo"
                    @input="countCharactersPerLine"
                    >
                    </el-input>
                </div>
                <div class="right">
                    <div class="list">
                        <div class="item" :class="{over: (Number(item) > Number(resultLength) || Number(item) == 0)}" v-for="(item, index) in splitList" :key="index">
                            {{ item }} / {{ resultLength }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <el-button @click="onClosed">取消</el-button>
            <el-button type="primary" @keydown.enter.native.prevent  @click="onSubmit">保存</el-button>
        </div>
    </div>
    </div>
</template>

<script>
    import {validEmoji} from '@/utils/validate'
    import { countBy, uniq, min, isEqual } from 'lodash'
    export default {
        name: 'mi_adTitle',
        props: [
            'cbs',
            'displayType',
            'eidtTitleList',
            'config'
        ],
        data() {
            return {
                textareaDemo: '',
                resultLength: 25,
                splitList: [],
                title:[] // 扔出数据
            }
        },
        created() {
            if(this.eidtTitleList && this.eidtTitleList.length !=0) {
                this.textareaDemo = this.eidtTitleList.join('\n')
                const characterCounts = this.eidtTitleList.map(line => line.length); // 获取每行的文字数并存储在数组中
                this.splitList = characterCounts
                this.title = this.eidtTitleList
            }
        },  
        mounted() {
            let res_length = []
            
            if(this.config['title_min_length']) {
                this.displayType.forEach(element => {
                    this.config['title_min_length'].forEach(item=>{
                        if(item['pid'] == element['param_id']) {
                            res_length.push(Number(item['param_name']))
                        }
                    })
                });
            }
            if(res_length.length == 0) {
                // 如果没标题的情况
            }else{
                this.resultLength = min(res_length)
            }
        },
        methods: {
            countCharactersPerLine(text) {
                this.textareaDemo = text.replace(/[ ]/g, '');
                const lines = this.textareaDemo.split('\n'); // 按换行符将文本拆分成行数组
                const characterCounts = lines.map(line => line.length); // 获取每行的文字数并存储在数组中
                this.title = lines
                this.splitList = characterCounts
                return characterCounts;
            },
            // 保存
            onSubmit() {
                if(validEmoji(this.textareaDemo)) {
                    this.$message.error('不可输入表情');
                    return
                }
                let over_num = this.splitList.some(item=> Number(item) > Number(this.resultLength))
                
                if(over_num) {
                    this.$message.error('内容为空或超出最大字符数量限制，请检查后重试');
                    return
                }
                let no_num = this.splitList.some(item=> Number(item) == 0)
                if(this.splitList.length != 1 && no_num) {
                    this.$message.error('内容为空或超出最大字符数量限制，请检查后重试');
                    return
                }
                const counts = countBy(this.title); 
                const duplicatesArray = this.title.filter(value => counts[value] > 1)

                if(duplicatesArray && duplicatesArray.length != 0 ){
                    this.$confirm('输入的内容，包含重复广告标题，已去重', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            this.cbs.onSubmit(uniq(this.title))
                        }).catch(() => {     
                    });
                    return
                }
                if(this.title.length == 1 && this.title[0] == '') {
                    this.title = []
                }
                this.cbs.onSubmit(uniq(this.title))
                
            },
            onClosed() {
                let uniqTitle = uniq(this.title)
                let result = isEqual(uniqTitle, this.eidtTitleList);
                if(!result) {
                    this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                    this.$emit('close')
                    }).catch(() => {});
                }else{
                    this.$emit('close')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.mi_adtitle-box{
    height: 100%;
    width: 100%;
    overflow-x: auto;
}
.mi_adtitle{
    width: 1200px;
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .con{
        height: 0;
        flex: 1;
        overflow: auto;
        margin-top: 16px;
    }
    .title-tip{
        width: 18px;
        height: 18px;
    }
    .tips{
        display: flex;
        span{
            padding-left: 8px;
        }
        margin-bottom: 10px;
    }
    .textarea_con{
        min-height: 400px;
        border: 1px solid #DCDFE6;
        display: flex;
        width: 100%;
        padding: 10px;
        .left{
            flex:  1;
        }
        .right{
            flex: 0 0 100px;
            padding-top: 5px;
            .item{
                padding: 0;
                margin: 0;
                font-size: 13px;
                line-height: 22px;
                height: 22px;
                &.over{
                    color: red;
                }
            }
        }
    }
    .footer {
        height: 60px;
        line-height: 60px;
        text-align: right;
        padding-right: 80px;
        margin: 0 -20px;
        box-shadow: 4px 0 4px #ccc;
    }
}
</style>
<style>
.mi_adtitle .el-textarea__inner{
    white-space: pre;
    line-height: 22px;
    font-size: 12px;
    border: none;
    resize: none;
}
</style>